import { Table } from "antd";
import Button from "../../Button";
import TextArea from "../../TextArea";
import Modules from "./Modules/Modules";
import constants from "../../../constants";
import Complexity from "./Complexity/Complexity";
import React, { useContext, useEffect } from "react";
import AlertContext from "../../../context/AlertContext";
import { LibraryContext } from "../../../context/LibraryContext";
import DescriptionHooks from "../../../Hooks/Question/DescriptionHooks";

export default function Description(Props) {
  const Alert = useContext(AlertContext);

  const DescriptionHks = DescriptionHooks();
  const LibraryCxt = useContext(LibraryContext);

  useEffect(() => {
    if (
      Alert.isqueReport &&
      Alert.tableShowStatus === constants.libTypeIds.SQL
    ) {
      const topicDetails = JSON.parse(Alert.selectque.topics).map((q) => ({
        topicid: q.topid,
        complexityid: q.compid,
        topicname:
          LibraryCxt.topics.find((t) => t.value === q.topid)?.label || "",
      }));

      const resultArray = topicDetails.map((qd, index) => ({
        key: index + 1,
        topicname: qd.topicname,
        complexity:
          LibraryCxt.complexities.find((c) => c.value === qd.complexityid)
            ?.label || "",
      }));

      LibraryCxt.setDataTopicAndComplexity(resultArray);
      LibraryCxt.setCount(resultArray.length);

      const topicDetailstoDb = JSON.parse(Alert.selectque.topics).map(
        (q, index) => ({
          type: "id",
          key: index + 1,
          value: q.topid,
          complexity: q.compid,
          name: LibraryCxt.topics.find((t) => t.value === q.topid)?.label || "",
        })
      );

      LibraryCxt.setTopicAndComplexity(topicDetailstoDb);
    }
  }, [LibraryCxt.topics, LibraryCxt.complexities]);

  return (
    <div className="descriptionMainContainer">
      <div className="descriptionTopicContainer">
        <Modules />
        <Complexity />
        <Button
          size="sm"
          onClick={DescriptionHks.handleAdd}
          disabled={
            LibraryCxt.topic?.name == null || LibraryCxt.level?.value == null
          }
          hierarchy={{
            type: "primary",
            buttonText: "Add",
          }}
        />
      </div>
      {LibraryCxt.dataTopicAndComplexity.length >= 1 && (
        <Table
          bordered
          pagination={false}
          columns={DescriptionHks.columns}
          dataSource={LibraryCxt.dataTopicAndComplexity}
        />
      )}
      <TextArea label="Question Name" value={Alert.testDetail?.name} />
      <TextArea
        label="Problem Statement"
        value={Alert.testDetail?.description === "undefined" ? "" : Alert.testDetail?.description}
      />
      <TextArea label="Explanation" value={Alert.testDetail?.ansexp === "undefined" ? "" : Alert.testDetail?.ansexp} />
    </div>
  );
}
